import Vue from 'vue'
export default Vue.extend({
  data:() => ({
    screenWidth: window.innerWidth
  }),
  computed: {
    xsScreen():boolean{
      return this.screenWidth < 600;
    },
    sScreen(): boolean {
      return this.screenWidth > 600 && this.screenWidth < 960;
    },
    mdScreen(): boolean{
      return this.screenWidth > 960 && this.screenWidth < 1264;
    },
    lgScreen(): boolean{
      return this.screenWidth > 1264 && this.screenWidth < 1904;
    },
    xlScreen():boolean{
      return this.screenWidth > 1904;
    }
  },
  methods: {
    windowResize(){
      this.screenWidth = window.innerWidth;
    }
  },
  mounted(){

    window.addEventListener('resize', this.windowResize);
  }
})